import {AuthenticatedUser} from "@gettactic/api";

export const authenticatedUserIsInMoreOrganizations = ( authenticatedUser: AuthenticatedUser ) => {
    if ( !authenticatedUser || !authenticatedUser.organizations ) {
        return false;
    }
    const { organizations } = authenticatedUser;

    return organizations.length > 1;
}